

































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";
import FormPrefillService from "@/services/FormPrefillService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import TglKontrolSkdpDatePicker from "@/components/form_components/TglKontrolSkdpDatePicker.vue";
import TabelPilihPenunjang from "./TabelPilihPenunjang.vue";
import TabelPilihHasilLab from "./TabelPilihHasilLab.vue";
import ModalResumeOptionItem from "@/components/modal/ModalResumeOptionItem.vue";
import { ResumeRalanBlanko } from "@/types/resumeRalanBlanko";
import { dariPrefill } from "@/utils/resumeRalanBlanko";
import { transaksiDariResepObat } from "@/utils/obatDariResep";
import ResepObatSvc from "@/services/ResepObat";
import { maskTekananDarah, validasiTekananDarah } from "@/utils/tekananDarah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

/** Cara Pulang "Pulang ke rumah" (`ref_discharge`). */
const DISCHARGE_PULANG = "1";

/** Gerbang PRB milik `CardDPP.isShowTlPrb` — jangan disederhanakan. */
const UNIT_GROUP_PRB = ["06", "10", "12", "13", "17", "27"];

@Component({
  components: {
    VCDateTimePicker,
    TglKontrolSkdpDatePicker,
    TabelPilihPenunjang,
    TabelPilihHasilLab,
    ModalResumeOptionItem
  }
})
export default class CardInputResumeRalan extends Vue {
  @Prop({ required: true }) readonly form!: ResumeRalanBlanko;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly dpjpTerkunci!: boolean;
  @Prop({ default: () => [] }) readonly listDokter!: Array<any>;
  @Prop({ default: () => [] }) readonly listDischarge!: Array<any>;
  @Prop() readonly register!: string | number;
  @Prop() readonly pasienRm!: string | number;

  ttvLoading = false;
  obatLoading = false;

  dialogObat = false;
  listObat: Array<any> = [];

  opsiKesadaran = [
    "Compos Mentis",
    "Apatis",
    "Somnolen",
    "Sopor",
    "Coma"
  ];

  opsiIter = ["1X", "2X"];

  tdRules = [(v: string) => validasiTekananDarah(v)];

  get stateuser() {
    return userModule.user;
  }

  get isPulangKeRumah(): boolean {
    return String(this.form.discharge_id) === DISCHARGE_PULANG;
  }

  get isShowTlPrb(): boolean {
    return (
      UNIT_GROUP_PRB.indexOf(this.stateuser.unit_group_id) !== -1 &&
      !!RegisterKunjungan.infoBpjs
    );
  }

  get opsiStabil(): string | null {
    if (this.form.tl_iterasi) return "iterasi";
    if (this.form.tl_rujuk_balik_fktp) return "fktp";
    if (this.form.tl_prb) return "prb";

    return null;
  }

  set opsiStabil(val: string | null) {
    this.form.tl_prb = val === "prb";
    this.form.tl_iterasi = val === "iterasi";
    this.form.tl_rujuk_balik_fktp = val === "fktp";

    if (val !== "iterasi") {
      this.form.tl_prb_note = null;
    }
  }

  get payloadSkdp() {
    return {
      tgl_kontrol: this.form.tl_tgl_kontrol,
      tujuan_kontrol: this.form.tl_kontrol_note,
      diagnosis: this.form.diagnosa_akhir,
      dpjp_id: this.form.dpjp_id
    };
  }

  get tglSuratDate(): Date | null {
    return composeDate(this.form.tgl_surat);
  }

  setTglSurat(val: Date | null) {
    this.form.tgl_surat = val ? toDateString(val) : null;
  }

  get tglKontrolDate(): Date | null {
    return composeDate(this.form.tl_tgl_kontrol);
  }

  setTglKontrol(val: Date | string | null) {
    if (!val) {
      this.form.tl_tgl_kontrol = null;
      return;
    }

    this.form.tl_tgl_kontrol =
      val instanceof Date ? toDateString(val) : String(val).substr(0, 10);
  }

  onTdInput(val: string) {
    const bersih = maskTekananDarah(val || "", this.form.pf_td || "");

    if (bersih === this.form.pf_td) {
      const field = this.$refs.tdRef as any;
      if (field) field.lazyValue = bersih;
    }

    this.form.pf_td = bersih;
  }

  async generateDariTtv() {
    if (this.ttvLoading || this.disabled) return;

    const adaIsi = [
      this.form.pf_ku,
      this.form.pf_kesadaran,
      this.form.pf_td,
      this.form.pf_nadi,
      this.form.pf_nafas,
      this.form.pf_suhu,
      this.form.pf_tinggi_badan,
      this.form.pf_berat_badan
    ].some(v => v !== null && v !== undefined && String(v).trim() !== "");

    if (
      adaIsi &&
      !window.confirm(
        "Pemeriksaan fisik sudah terisi. Generate akan menimpanya. Lanjutkan?"
      )
    ) {
      return;
    }

    this.ttvLoading = true;

    try {
      const payload = await FormPrefillService.fetchPrefill(
        String(this.pasienRm),
        "resume_ralan",
        {
          register_id: this.register,
          unit_id: this.stateuser.unit_id,
          sources: ["klinis_terkini"]
        }
      ).catch(() => null);

      if (!payload) {
        appModule.sendErrorAlert("Tidak ada data TTV pada kunjungan ini.");
        return;
      }

      const sumber: any = dariPrefill(payload.fields as any);
      const terisi: Array<string> = [];

      Object.keys(sumber).forEach(kunci => {
        if (kunci.indexOf("pf_") !== 0) return;

        const nilai = sumber[kunci];
        if (nilai === null || nilai === undefined || nilai === "") return;

        (this.form as any)[kunci] = nilai;
        terisi.push(kunci);
      });

      appModule.NoticeDelay(
        terisi.length
          ? terisi.length + " kolom pemeriksaan fisik terisi dari TTV"
          : "Tidak ada data TTV yang dapat dipakai"
      );
    } finally {
      this.ttvLoading = false;
    }
  }

  async bukaObat() {
    if (this.obatLoading || this.disabled) return;

    this.obatLoading = true;

    try {
      await storeHasilPenunjang.getObatByRegister(this.register).catch(
        () => undefined
      );

      const trxFarmasi = storeHasilPenunjang.listTrxObat || [];

      this.listObat = trxFarmasi.length
        ? trxFarmasi
        : await this.resepBelumDilayani();

      this.dialogObat = true;
    } finally {
      this.obatLoading = false;
    }
  }

  async resepBelumDilayani(): Promise<Array<any>> {
    const resp = await ResepObatSvc.getByRegister(this.register).catch(
      () => undefined
    );

    const list = resp && resp.data ? resp.data.data : null;

    return transaksiDariResepObat(list || []);
  }

  terapkanObat(val: Array<string>) {
    const teks = (val || [])
      .filter(s => !!s)
      .map(s => String(s).replace(/\s+/g, " ").trim())
      .filter(s => !!s)
      .join(";\r\n");
    if (!teks) return;

    const lama = String(this.form.terapi_tindakan || "");
    this.form.terapi_tindakan = lama ? lama + ";\r\n" + teks : teks;
  }
}
